export const bannerType = {
  TargetedAD: "Targeted",
  GenericAD: "Generic",
};

const bannerTypes = [
  { code: bannerType.GenericAD, name: "Generic Ad" },
  { code: bannerType.TargetedAD, name: "Targeted Ad" },
];

export const bannerPosition = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
  BOTH: "BOTH",
  CARD: "CARD",
};

export const frontendPages = {
  MODEL: "Model",
  POPULAR_SEARCH: "Popular-Search",
  BRAND: "Brand",
};

export const pageLists = [
  { code: frontendPages.MODEL, name: "Model" },
  { code: frontendPages.POPULAR_SEARCH, name: "Popular Search" },
  { code: frontendPages.BRAND, name: "Brand" },
];

export const bannerPostions = [
  { code: bannerPosition.TOP, name: "Top" },
  { code: bannerPosition.BOTTOM, name: "Bottom" },
  { code: bannerPosition.BOTH, name: "Both" },
];

export default bannerTypes;
